<div class="container">
  <div class="btn btn-secondary arrow return mb-4 mt-4" routerLink="/">Retour</div>
  <div class="login-box">
    <div class="text-center">
      <div *ngIf="success == true" class="text-center">
        <h1 class="title mb-2 mb-sm-4 text-uppercase">E-mail envoyé</h1>
      </div>
      <div *ngIf="success == false" class="text-center">
        <h1 class="title mb-2 mb-sm-4">MOT DE PASSE OUBLIÉ ?</h1>
      </div>
    </div>
    
    <div *ngIf="success == true" class="text-center">
      <p>Si un compte du club correspond à votre e-mail, vous devriez recevoir un e-mail de redéfinition de mot de passe. Merci de vérifier la boîte de courriers indésirables (spam) si nécessaire.</p>

        <a routerLink="/" class="btn btn-secondary arrow return">Retour</a>
    </div>
  
    <form *ngIf="success == false" [formGroup]="form" (ngSubmit)="onSubmit()" class="form-spec">
        <p class="mb-4">Renseignez votre adresse e-mail afin de réinitialiser votre mot de passe.</p>
        <div class="form-group mb-4">
            <label for="username">E-mail</label>
            <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['username'].errors }" />
            <div *ngIf="submitted && f['username'].errors" class="invalid-feedback">
                <div *ngIf="f['username'].errors['required']">Ce champ est obligatoire</div>
                <div *ngIf="f['username'].errors['email']">Ce n'est pas un e-mail valide</div>
            </div>
        </div>
        <div class="mb-2 text-center">
          <button [disabled]="loading" class="btn btn-primary">
              Valider
          </button>
        </div>
    </form>
  </div>
</div>